module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.9dbcf2b2.mp3";